import DynamicDropdown from "../../Components/Dropdown/DynamicDropdown";
import StaticDropdown from "../../Components/Dropdown/StaticDropdown";
import UsersDropdown from "../../Components/Dropdown/Users/UsersDropdown";
import { IDeltaHedgeOrderTablesSearchParam } from "../../Interfaces/deltaHedgeOrder";
import { getStepInstruments } from "../../Requests/stepRequests";
import { deltaHedgeOrderTypesDropdownOptions } from "./DeltaHedgeOrder";

interface IProps {
  onChange: (name: string, value: any) => void;
  searchParam: IDeltaHedgeOrderTablesSearchParam;
}

const SearchParamBox = ({ onChange, searchParam }: IProps) => {
  return (
    <div className="w-full flex flex-row  justify-start items-center gap-2">
      <div className="w-48">
        <StaticDropdown
          dropdown={{
            name: "deltaHedgeOrderType",
            placeholder: "فرایند",
          }}
          onChange={onChange}
          options={deltaHedgeOrderTypesDropdownOptions}
          value={searchParam.deltaHedgeOrderType}
        />
      </div>
      <div className="w-48">
        <DynamicDropdown
          dropdown={{
            name: "instrumentId",
            placeholder: "نماد",
          }}
          onChange={onChange}
          getData={getStepInstruments}
          value={searchParam.instrumentId}
        />
      </div>

      <div className="w-48">
        <UsersDropdown
          label="اکانت"
          name="accountId"
          value={searchParam.accountId}
          onChange={onChange}
        />
      </div>
    </div>
  );
};

export default SearchParamBox;
